// extracted by mini-css-extract-plugin
module.exports = {"fab":"ChatLauncherButton_fab__XPzi3","icon":"ChatLauncherButton_icon__1L2--","badge":"ChatLauncherButton_badge__J_o7x","minimizedDot":"ChatLauncherButton_minimizedDot__1pSe-"};